<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :validations="validations.aberturaOcular"
                    label="Resposta ocular"
                    v-model="model.aberturaOcular.id"
                >
                    <template v-slot:label-trailing>
                        <rkm-icon
                            icon="info-circle"
                            title="Se houver lesão local, edema ou de outra forma incapaz de ser avaliado, marque Não testável (NT)"
                            v-rkm-tooltip.hover
                        />
                    </template>

                    <rkm-form-select-option
                        :value="null"
                        slot="first"
                    >
                        Selecione
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="1">
                        1 - Nenhuma
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="2">
                        2 - À pressão
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="3">
                        3 - Estímulo verbal
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="4">
                        4 - Espontânea
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="5">
                        NT - Não testável
                    </rkm-form-select-option>
                </rkm-form-select>
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :validations="validations.respostaVerbal"
                    label="Resposta verbal"
                    v-model="model.respostaVerbal.id"
                >
                    <template v-slot:label-trailing>
                        <rkm-icon
                            icon="info-circle"
                            title="Se entubado ou de outra forma incapaz de ser avaliado, marque Não testável (NT)"
                            v-rkm-tooltip.hover
                        />
                    </template>

                    <rkm-form-select-option
                        :value="null"
                        slot="first"
                    >
                        Selecione
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="1">
                        1 - Nenhuma
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="2">
                        2 - Sons
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="3">
                        3 - Palavras
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="4">
                        4 - Confuso
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="5">
                        5 - Orientado
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="6">
                        NT - Não testável
                    </rkm-form-select-option>
                </rkm-form-select>
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :validations="validations.respostaMotora"
                    label="Resposta motora"
                    v-model="model.respostaMotora.id"
                >
                    <template v-slot:label-trailing>
                        <rkm-icon
                            icon="info-circle"
                            title="Se em sedação / paralisia ou incapaz de ser avaliado, marque Não testável (NT)"
                            v-rkm-tooltip.hover
                        />
                    </template>

                    <rkm-form-select-option
                        :value="null"
                        slot="first"
                    >
                        Selecione
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="1">
                        1 - Nenhuma
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="2">
                        2 - Extensão
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="3">
                        3 - Flexão anormal
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="4">
                        4 - Flexão normal
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="5">
                        5 - Localizando
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="6">
                        6 - Obedece a comandos
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="7">
                        NT - Não testável
                    </rkm-form-select-option>
                </rkm-form-select>
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    label="Resposta pupilar"
                    v-model="model.reatividadePupilar.id"
                    :validations="validations.reatividadePupilar"
                >
                    <rkm-form-select-option :value="3">
                        0 - Completa
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="1">
                        -1 - Parcial
                    </rkm-form-select-option>

                    <rkm-form-select-option :value="2">
                        -2 - Inexistente
                    </rkm-form-select-option>
                </rkm-form-select>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.observacoes"
                    label="Observações"
                    max-rows="5"
                    v-model="model.observacoes"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :value="pontuacao"
                    disabled
                    label="Pontuação"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :value="resultado"
                    disabled
                    label="Resultado"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        pontuacao() {

            let pontuacao = 0

            if (this.model.aberturaOcular.id !== null) {

                pontuacao += this.data.form.glasgow.aberturasOcular
                    .find(a => a.id === this.model.aberturaOcular.id).pontos
            }

            if (this.model.respostaVerbal.id !== null) {

                pontuacao += this.data.form.glasgow.respostasVerbal
                    .find(r => r.id === this.model.respostaVerbal.id).pontos
            }

            if (this.model.respostaMotora.id !== null) {

                pontuacao += this.data.form.glasgow.respostasMotora
                    .find(r => r.id === this.model.respostaMotora.id).pontos
            }

            if (this.model.reatividadePupilar.id !== null) {

                pontuacao -= this.data.form.glasgow.reatividadesPupilar
                    .find(r => r.id === this.model.reatividadePupilar.id).pontos
            }

            return pontuacao
        },
        resultado() {

            if (this.model.aberturaOcular.id === null
                || this.model.respostaVerbal.id === null
                || this.model.respostaMotora.id === null
                || this.model.reatividadePupilar.id === null
            ) {

                return ''
            }

            if (this.model.aberturaOcular.id === 5
                || this.model.respostaVerbal.id === 6
                || this.model.respostaMotora.id === 7
            ) {
                return 'A pontuação não pode ser calculada. Um ou mais itens não foram testados'
            }
            else {
                if (this.pontuacao >= 1 && this.pontuacao <= 4) {
                    return 'Coma irreversível'
                }
                else if (this.pontuacao >= 5 && this.pontuacao <= 6) {
                    return 'Coma profundo'
                }
                else if (this.pontuacao >= 7 && this.pontuacao <= 8) {
                    return 'Coma superficial'
                }
                else if (this.pontuacao >= 9 && this.pontuacao <= 10) {
                    return 'Torporoso'
                }
                else if (this.pontuacao >= 11 && this.pontuacao <= 12) {
                    return 'Letárgico'
                }
                else if (this.pontuacao >= 13 && this.pontuacao <= 14) {
                    return 'Confuso'
                }
                else if (this.pontuacao === 15) {
                    return 'Consciente'
                }
                else {
                    return 'Sem resultado'
                }
            }
        },
        validations() {
            return {
                aberturaOcular: { required: true },
                respostaVerbal: { required: true },
                respostaMotora: { required: true },
                reatividadePupilar: { required: true },
                observacoes: { max: 2500 },
            }
        },
    },
    methods: {
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    if (this.model.id) {
                        this.model = Object.assign(this.model, {
                            pontuacao: this.pontuacao,
                            resultado: this.resultado,
                        })

                        const index = this.data.model.escalasComaGlasgow.findIndex(item => item.id === this.model.id)
                        Object.assign(this.data.model.escalasComaGlasgow[index], this.model)
                    } else {
                        this.model = Object.assign(this.model, {
                            id: this.uniqueId('pronto-atendimento-observacao-escala-coma-glasgow'),
                            pontuacao: this.pontuacao,
                            resultado: this.resultado,
                        })

                        this.data.model.escalasComaGlasgow.push(this.model)
                    }

                    this.$emit('saved', this.model)
                }
            })
        },
    },
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'model.aberturaOcular.id': function (id) {

            this.model.aberturaOcular.pontos = id
                ? this.data.form.glasgow.aberturasOcular.find(a => a.id === id).pontos
                : 0
        },
        'model.respostaVerbal.id': function (id) {

            this.model.respostaVerbal.pontos = id
                ? this.data.form.glasgow.respostasVerbal.find(r => r.id === id).pontos
                : 0
        },
        'model.respostaMotora.id': function (id) {

            this.model.respostaMotora.pontos = id
                ? this.data.form.glasgow.respostasMotora.find(r => r.id === id).pontos
                : 0
        },
        'model.reatividadePupilar.id': function (id) {

            this.model.reatividadePupilar.pontos = id
                ? this.data.form.glasgow.reatividadesPupilar.find(r => r.id === id).pontos
                : 0
        },
    }
}
</script>